// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dt-b";
export var colorBlue = "_dt-8";
export var colorDot = "_dt-0";
export var colorDotLarge = "_dt-2";
export var colorDotSmall = "_dt-1";
export var colorGreen = "_dt-7";
export var colorGrey = "_dt-3";
export var colorOrange = "_dt-5";
export var colorPink = "_dt-a";
export var colorPurple = "_dt-9";
export var colorRed = "_dt-4";
export var colorYellow = "_dt-6";